import { Button } from 'primereact/button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import 'date-fns';
// import { useFormik } from "formik";
import * as React from 'react';
import { MemberService } from '../../../remote-api/api/member-services';
import { EO2V2Autocomplete } from '../../../shared-components';
import { Autocomplete } from '@material-ui/lab';
import { ClientTypeService, PlanService } from '../../../remote-api/eo2v2-remote-api';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@material-ui/core';
import { StatefulTargetBox as TargetBox } from './targetbox';

const memberservice = new MemberService();
const planservice = new PlanService();
const clienttypeervice = new ClientTypeService();

export default function InstallmentModal(props) {
  console.log(props);

  const handleClose = () => {
    props.closeInstallmentModal();
  };

  const formatDate = ms => {
    const date = new Date(ms);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <Dialog
      open={props.openInstallment}
      onClose={handleClose}
      fullWidth={false}
      maxWidth="lg"
      aria-labelledby="form-dialog-title">
      {/* <DialogTitle id="form-dialog-title"> Installment </DialogTitle> */}
      <Box p={2}>
        <Table size="small" sx={{ minWidth: 650 }} aria-label="installment summary table">
          <TableHead>
            <TableRow>
              <TableCell>Sl#</TableCell>
              <TableCell>Installment Amount</TableCell>
              <TableCell>Commission</TableCell>
              <TableCell>Stamp Duty</TableCell>
              <TableCell>Tax</TableCell>
              <TableCell>Paid Amount</TableCell>
              <TableCell>Installment Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.instalmentData?.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.instalmentAmount}</TableCell>
                <TableCell>{row.commision}</TableCell>
                <TableCell>{row.stampDuty}</TableCell>
                <TableCell>{row.tax[0]?.value}</TableCell>
                <TableCell>{row.paidAmount}</TableCell>
                <TableCell>{formatDate(row.tax[0]?.effectiveFrom)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
      <Box style={{ marginTop: '1rem' }}>
        <DialogContent>
          {props?.customInstallment.map((row, idx) => (
            <Grid container spacing={2} alignItems="center" key={idx} style={{ marginBottom: '8px' }}>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Installment Amount"
                  value={row.amount}
                  onChange={e => props?.updateField(idx, 'amount', e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Commission"
                  value={row.commission}
                  onChange={e => props?.updateField(idx, 'commission', e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Stamp Duty"
                  // value={row.stampDuty}
                  value={idx === 0 ? row.stampDuty : '0.00'}
                  // onChange={e => props?.updateField(idx, 'stampDuty', e.target.value)}
                  onChange={e => props?.updateField(idx, 'stampDuty', e.target.value)}
                  disabled={idx !== 0}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Tax Amount"
                  value={row.taxAmount}
                  onChange={e => props?.updateField(idx, 'taxAmount', e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  label="Paid Amount"
                  value={row.paidAmount}
                  onChange={e => props?.updateField(idx, 'paidAmount', e.target.value)}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  fullWidth
                  size="small"
                  type="date"
                  label="Installment Date"
                  value={row.date}
                  InputLabelProps={{ shrink: true }}
                  onChange={e => props?.updateField(idx, 'date', e.target.value)}
                />
              </Grid>

              {/* Remove button */}
              <Grid item xs={12} container justifyContent="flex-end">
                {props?.customInstallment.length > 1 && (
                  <Tooltip title="Remove">
                    <Button variant="contained" color="secondary" onClick={() => props?.handleRemoveInstallment(idx)}>
                      <DeleteIcon />
                    </Button>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          ))}
          <Grid container justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={props?.handleAddInstallment}>
              <AddIcon /> Add More
            </Button>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button color="secondary" onClick={props.handleSubmitInstallments}>
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
